export const ROW_ESTIMATE_HEIGHT = 49;
export const LOAD_MORE_THRESHOLD = 5;

export const HEADER_AND_BOTTOM_RESERVE_HEIGHT = 140; // Space reserved for the table header and page paddings/footer below the table
export const INITIAL_HEIGHT_PAGE_RATIO = 0.7; // Initial height before the first measurement, as a share of page height
export const MIN_BODY_HEIGHT = ROW_ESTIMATE_HEIGHT; // Keeps one row visible even when the table starts below the fold

export const CHECKBOX_COLUMN_WIDTH = 50;
export const EXPAND_COLUMN_WIDTH = 48;
export const DEFAULT_COLUMN_WIDTH = 120;
export const SIZELESS_FLEX_GROW = 9999999; // Emulates native table behavior when columns without widths take all available space
